// Chakra imports
import {
  Flex,
  Text,
  useColorModeValue,
  Stack,
  Spacer,
  Button,
  Icon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
} from "@chakra-ui/react";
// Custom components

import Card from "./../../../../components/Card/Card";
import CardBody from "./../../../../components/Card/CardBody";
import CardHeader from "./../../../../components/Card/CardHeader";
import { TbTrashX } from "react-icons/tb";
import React, { useRef, useState } from "react";
import { gql, useMutation } from "@apollo/client";

const uploadFileGql = gql`
  mutation uploadRealEstateBrokerMedia($input: UploadRealEstateBrokerMediaInput!) {
    uploadRealEstateBrokerMedia(input: $input)
  }
`;

const deleteFileGql = gql`
  mutation deleteRealEstateBrokerMedia($input: DeleteRealEstateBrokerMediaInput!) {
    deleteRealEstateBrokerMedia(input: $input)
  }
`;

// mediaType: LOGO | PLANNER_TOP
const EstateBrokerMedia = ({ data, forceRerender, mediaType }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [deleteMediaId, setdeleteMediaId] = useState("");
  const [uploadFile, { loading: loadingUpload, data: dataUpload }] = useMutation(uploadFileGql);
  const [deleteFile, { loading: loadingDelete, data: dataDelete }] = useMutation(deleteFileGql);
  const inputRef = useRef(null);
  const textColor = useColorModeValue("gray.700", "white");

  if (!loadingUpload && dataUpload?.uploadRealEstateBrokerMedia) {
    setTimeout(() => {
      forceRerender();
    }, 500);
  }

  if (!loadingDelete && dataDelete) {
    setTimeout(() => {
      forceRerender();
    }, 500);
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleDeleteMediaClick = (id) => {
    setdeleteMediaId(id);
    onOpen();
  };

  const deleteMedia = () => {
    onClose();

    const inputData = {
      realEstateBrokerId: data.id,
      mediaId: deleteMediaId,
    };

    deleteFile({ variables: { input: inputData } });
  };

  const handleUploadClick = () => {
    inputRef.current?.click();
  };

  async function handleFileChange(e) {
    if (!e.target.files) {
      return;
    }

    const fileBase64 = await toBase64(e.target.files[0]);

    const inputData = {
      realEstateBrokerId: data.id,
      mediaType: mediaType,
      filename: e.target.files[0].name,
      mimeType: e.target.files[0].type,
      fileContentBase64: fileBase64,
    };

    uploadFile({ variables: { input: inputData } });
  }

  const downloadMedia = (mediaUrl) => {
    window.open(mediaUrl);
  };

  const media = mediaType === "LOGO" ? data.logo : data.plannerTop;

  return (
    <Card p="16px" my={{ sm: "24px", xl: "0px" }}>
      <CardHeader style={{ justifyContent: "space-between" }}>
        <Text fontSize="lg" color={textColor} fontWeight="bold">
          {mediaType === "LOGO" ? "Logo" : "Planner top billede"}
          <Text fontSize="sm" color={textColor} fontWeight="bold">
            {mediaType === "LOGO" ? "150x150 px" : "1300 x 480 px"}
          </Text>
        </Text>

        {!media && (
        <Text fontSize="lg" color="gray.400" cursor="pointer" onClick={() => handleUploadClick()}>
          Upload
        </Text>
        )}
        <input type="file" ref={inputRef} onChange={handleFileChange} style={{ display: "none" }} />
      </CardHeader>

      <CardBody w="100%" pt="28px" style={{ flexDirection: "column" }}>
        {media && (
          <Stack key={media.id} direction="column" spacing="24px" w="100%" style={{ paddingTop: "10px" }}>
            <Flex align="center" w="100%">
              <Flex align="center">
                <img
                  src={media.mediaUrl}
                  alt='Ikon for produkt kategorien'
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    border: "1px solid rgb(207 207 207)",
                    marginRight: "20px",
                  }}
                />
                <Flex direction="column" cursor="pointer" onClick={() => downloadMedia(media.mediaUrl)}>
                  <Text fontSize="sm" fontWeight="bold" color={textColor}>
                    {media.filename}
                  </Text>
                  <Text color="gray.400" fontSize="xs">
                    {media.filename}
                  </Text>
                </Flex>
              </Flex>
              <Spacer />
              <Button variant="transparent-with-icon" px="0px">
                <Icon as={TbTrashX} color="gray.400" w="30px" h="30px" cursor="pointer" onClick={() => handleDeleteMediaClick(media.id)} />
              </Button>
            </Flex>
          </Stack>
        )}
      </CardBody>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={deleteMedia}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Slet {mediaType === "LOGO" ? "logo" : "top billede"}
            </AlertDialogHeader>

            <AlertDialogBody>Er du sikker?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Fortryd
              </Button>
              <Button colorScheme="red" onClick={deleteMedia} ml={3}>
                Slet
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Card>
  );
};

export default EstateBrokerMedia;
